@use "styles" as *;

.me-article {
  display: block;

  &__teaser {
    font-weight: $font-weight-bold;
  }

  me-section[theme=neutral] {
    margin-block: $block-margin;
  }
}
